// Lightweight global counter of open overlays (bottom sheets, side panels,
// notification drawers). Components that render full-screen overlays
// increment on mount / decrement on unmount so other floating UI (e.g. the
// AI bubble) can hide itself to avoid z-index fights and visual clutter.

import { create } from 'zustand'

interface OverlayStore {
  openCount: number
  /** Call when an overlay mounts. */
  push: () => void
  /** Call when an overlay unmounts. */
  pop: () => void
}

export const useOverlayStore = create<OverlayStore>((set) => ({
  openCount: 0,
  push: () => set((s) => ({ openCount: s.openCount + 1 })),
  pop: () => set((s) => ({ openCount: Math.max(0, s.openCount - 1) })),
}))
